export default __webpack_public_path__ + "static/2-start-screen-18bd6ed91dcfea7aac5968ee067bccc0.jpg";